import { Locator } from '@/lib/test.locators';

export const templateCardLocatorMap = [
  {
    type: 'function',
    element: 'div',
    id: 'templateCard',
    property: (id: string) => `template-card-${id}`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'templateCardNameButton',
    property: (id: string) => `template-card-${id}-name-button`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'templateCardNameValue',
    property: (id: string) => `template-card-${id}-name-value`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'templateCardDropdownTrigger',
    property: (id: string) => `template-card-${id}-dropdown-trigger`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'templateCardDropdownTriggerEdit',
    property: (id: string) => `template-card-${id}-dropdown-trigger-edit`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'templateCardDropdownTriggerStatusChange',
    property: (id: string) => `template-card-${id}-dropdown-trigger-status-change`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'templateCardDropdownTriggerDelete',
    property: (id: string) => `template-card-${id}-dropdown-trigger-delete`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'templateCardDescription',
    property: (id: string) => `template-card-${id}-description`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'templateCardStatusText',
    property: (id: string) => `template-card-${id}-status-text`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'templateCardStatusValue',
    property: (id: string) => `template-card-${id}-status-value`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'templateCardOwnerText',
    property: (id: string) => `template-card-${id}-owner-text`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'templateCardOwnerValue',
    property: (id: string) => `template-card-${id}-owner-value`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'templateCardBusinessUnitText',
    property: (id: string) => `template-card-${id}-business-unit-text`,
  },
  {
    type: 'function',
    element: 'p',
    id: 'templateCardBusinessUnitValue',
    property: (id: string) => `template-card-${id}-business-unit-value`,
  },
  {
    type: 'function',
    element: 'button',
    id: 'templateCardUseAsNewProductButton',
    property: (id: string) => `template-card-${id}-use-as-new-product-button`,
  },
] as const;

type TemplateCardLocatorId = Locator<typeof templateCardLocatorMap>;
type TemplateCardReturn = (id: string) => string;

export const templateCardLocators: Record<TemplateCardLocatorId, TemplateCardReturn> = templateCardLocatorMap.reduce(
  (acc, { id, property }) => {
    acc[id] = property;
    return acc;
  },
  {} as Record<TemplateCardLocatorId, TemplateCardReturn>,
);
